import packageJSON from '../../package.json'

const Index = (): JSX.Element => {
  return (
    <p className="font-light tracking-wider uppercase text-xs">
      <small>V{packageJSON.version}</small>
    </p>
  )
}

export default Index
